module.exports = __webpack_public_path__ + "img/rrrrr.88652d89.png";